// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I1Pl","col":"styles_col__3qWkn"};